define('view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyView',['require','view/controller/booking/datetime/slots/TimeSlotsView','view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyDayView','Config'],function (require) {

    var TimeSlotsView = require('view/controller/booking/datetime/slots/TimeSlotsView');
    var TimeSlotsWeeklyDayView = require('view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyDayView');
    var Config = require('Config');

    /**
     * Slots weekly timeline view (container)
     *
     * @class TimeSlotsWeeklyView
     */
    return TimeSlotsView.extend({

        template: '#time_slots_weekly_view',
        childViewContainer: '#sb_time_slots_weekly_container',
        childView: TimeSlotsWeeklyDayView,
        
        childViewOptions: function (model, index) {
            return _.extend({}, TimeSlotsView.prototype.childViewOptions.apply(this, arguments), {
                bookingModel: this.getOption('bookingModel'),
                isDayOff : this._calendarCollection.isDayOff(model.get('date')),
                isWlAvailable : this._calendarCollection.isWlAvailable(model.get('date'))
            });
        },
        
        childEvents: {
            'select:time': 'onTimeSelected'
        },

        _daysDiff: 7,

        initialize: function () {
            this._timeCollection = this.getOption('timeCollection');
            this._calendarCollection = this.getOption('calendarCollection');

            if (this._timeCollection.length) {
                this._updateCollection();
            }

            this.listenTo(this._timeCollection, 'sync', _.bind(function () {
                this._updateCollection();
                this.render();
            }, this));

            this.listenTo(this._calendarCollection, 'sync', _.bind(function () {
                this._updateCollection();
                this.render();
            }, this));

            TimeSlotsView.prototype.initialize.apply(this);
        },

        _updateCollection: function () {
            this.collection = this._timeCollection.getCollectionGroupedByClientDay();
        },

        getTimeCollection: function () {
            return this._timeCollection;
        },

        serializeData: function () {
            var isWlEnabled = Config.getInstance().getPluginStatus('waiting_list');
            var data = {};
            if (this.collection) {
                var first = this.collection.first();
                var last = this.collection.last();
                if (first && last) {
                    data = {
                        'from': first.get('date'),
                        'to': last.get('date')
                    };
                }
            }

            data.is_empty = isWlEnabled?false:this.isEmptyDayCollection();
            return _.extend(TimeSlotsView.prototype.serializeData.apply(this), data);
        },

        isEmptyDayCollection: function () {
            if (!this.getOption('clientTimeZone').isReady()) {
                return true;
            }

            return this._timeCollection.isEmptyDayCollection();
        },

        filter: function (child, index, collection) {
            var isWlEnabled = Config.getInstance().getPluginStatus('waiting_list');
            if (!this.getOption('clientTimeZone').isReady()) {
                return false;
            }

            return isWlEnabled?true:!this._timeCollection.isEmptyDayCollection();
        },
        
        onTimeSelected: function (view, data) {
            var model = data.model;
            this.triggerMethod('timeChanged', model.get('time'), model.get('date'));
        }

    });

});
